// ABOUTME: Amazon SP-API login-URI entry point. Stashes Amazon's three query
// ABOUTME: params in localStorage with a 1h TTL, then routes to login or saleschannels.

import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import Text from '../../components/theme/text/Text';
import { useTranslation } from 'react-i18next';
import { selectAuthStatus, UserState } from '../../newapi/user/authentication/authSlice';
import { useSelector } from 'react-redux';

const AmazonSetup = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const authStatus = useSelector(selectAuthStatus);

    useEffect(() => {
        const amazonCallbackUri = searchParams.get('amazon_callback_uri');
        const amazonState = searchParams.get('amazon_state');
        const sellingPartnerId = searchParams.get('selling_partner_id');

        if (amazonCallbackUri && amazonState && sellingPartnerId) {
            const expires = new Date();
            expires.setTime(expires.getTime() + (60 * 60 * 1000));

            localStorage.setItem('amazon_installation_callback_uri', amazonCallbackUri);
            localStorage.setItem('amazon_installation_state', amazonState);
            localStorage.setItem('amazon_installation_selling_partner_id', sellingPartnerId);
            localStorage.setItem('amazon_installation_expires', expires.toUTCString());

            if (authStatus === UserState.LOGGED_IN) {
                navigate('/relation/integrations/saleschannels?view=all');
            } else {
                navigate('/login');
            }
        } else {
            navigate('/login');
        }
    }, [searchParams, navigate, authStatus]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                gap: 2,
            }}
        >
            <CircularProgress />
            <Text>{t('setting_up_shopify_integration')}</Text>
        </Box>
    );
};

export default AmazonSetup;
